import styled from 'styled-components';

export default styled.div`
  display: flex;
  padding: 15px;
  flex-direction: column;
`;
